import { Group, Pagination, Select, Text } from "@mantine/core";
import classes from "./appPagination.module.scss";

export function AppPagination({
    page,
    take,
    total,
    onPageChange,
    onTakeChange,
    takeOptions = [20, 50, 100],
}) {
    const totalPages = Math.max(1, Math.ceil(total / take));

    const handleTakeChange = (value) => {
        if (!value) return;
        const newTake = Number(value);
        onTakeChange(newTake);
        onPageChange(1);
    };

    return (
        <div className={classes["pagination-sticky"]}>
            <Group justify="center" gap={20} align="center" >
                <Pagination
                    withEdges
                    value={page + 1}
                    onChange={onPageChange}
                    total={totalPages}
                />
                <Text size="sm">Per page</Text>
                <Select
                    value={String(take)}
                    onChange={handleTakeChange}
                    data={takeOptions.map((n) => ({
                        value: String(n),
                        label: `${n} `,
                    }))}
                    w={100}
                />
            </Group>
        </div>
    );
}